import _ from 'lodash';

export const genBasicHooks = (hooks, props) => {
    const basicHooks = hooks(props);

    basicHooks.usePlugin = function usePlugin(plugin, _props) {
        if (_.isFunction(plugin)) {
            return plugin(this, _props);
        }
        return null;
    };

    return basicHooks;
};

export default {
    genBasicHooks,
};
